// src/data/faq/index.ts
import { getSiteConfig } from "@/config/siteConfigs";

export const getFaqDataBerlin = async () => {
  const siteConfig = getSiteConfig();

  switch (siteConfig.language) {
    case "de":
      return import("./faqDataBerlin.de").then(
        (module) => module.faqDataBerlinDE
      );
    case "ua":
      return import("./faqDataBerlin.ua").then(
        (module) => module.faqDataBerlinUA
      );
    case "pl":
      return import("./faqDataBerlin.pl").then(
        (module) => module.faqDataBerlinPL
      );
    case "cz":
      return import("./faqDataBerlin.cz").then(
        (module) => module.faqDataBerlinCZ
      );
    default:
      return import("./faqDataBerlin.de").then(
        (module) => module.faqDataBerlinDE
      );
  }
};

export const getFaqDataEU = async () => {
  const siteConfig = getSiteConfig();

  switch (siteConfig.language) {
    case "de":
      return import("./faqDataEU.de").then((module) => module.faqDataEUDE);
    case "ua":
      return import("./faqDataEU.ua").then((module) => module.faqDataEUUA);
    case "pl":
      return import("./faqDataEU.pl").then((module) => module.faqDataEUPL);
    case "cz":
      return import("./faqDataEU.cz").then((module) => module.faqDataEUCZ);
    default:
      return import("./faqDataEU.de").then((module) => module.faqDataEUDE);
  }
};
